import { LogboekItem } from "@/entities/logboek/domain";
import { FilterType } from "../tijdlijn";

export const filterPredicates: Partial<Record<FilterType, (entry: LogboekItem) => boolean>> = {
    [FilterType.SPOORWEB]: (entry) => entry.bron === "Spoorweb",
    [FilterType.RCB]: (entry) => entry.bron === "Regiecentrum Bus",
    [FilterType.KLANTENSERVICE]: (entry) => entry.bron === "Klantenservice",
    [FilterType.REGIEVOERDER]: (entry) => entry.bron === "Regievoerder",
    [FilterType.BERICHTEN]: (entry) => typeof entry.bericht === "string" && entry.bericht.trim() !== "",
};
